import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { SortIcon } from 'src/domains/layouts/shared/assets/icons/brand/SortIcon';
import { withConfig } from 'src/withConfig';

export const StyledContainer = styled('div', { label: 'StyledContainer' })`
    position: relative;
    height: 32px;
`;

export const SortIconWrapper = withConfig(theme => styled(SortIcon, { label: 'SortIconWrapper' })`
    width: 32px;
    height: 32px;
    padding: 6px;
    stroke: ${theme.star.raceCard.dropdown.bgColorTertiary};
    @media ${theme.star.mediaQuery.desktop} {
        padding: 0;
    }
`);

export const StyledSelectedContainer = withConfig(theme => styled('div', { label: 'StyledSelectedContainer' })<{ selected: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    padding: 12px 9px;
    background: ${({ selected }): string => selected ? theme.star.raceCard.dropdown.bgColorSecondary : theme.star.raceCard.dropdown.bgColor};
    cursor: pointer;

    &:hover {
        background: ${theme.star.raceCard.dropdown.bgColorSecondary};
    }
`);

interface StyledDropdownMenuPropsType {
    variant: DefaultComponentVariantType | null;
}

const setStyledDropdownMenu = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            border-radius: ${theme.star.radius.medium};
            overflow: hidden;
        `;
    }
    return css``;
};


export const StyledDropdownMenu = withConfig(theme => styled('div', { label: 'StyledDropdownMenu' })<StyledDropdownMenuPropsType>`
    ${({ variant }): SerializedStyles=> setStyledDropdownMenu(variant, theme)};
    position: absolute;
    z-index: ${theme.star.zIndexGlobal.above};

    list-style-type: none;
    right: 0;
    padding: 0;

    width: 120px;
`);

export const StyledDropdownMenuItem = withConfig(theme => styled('div', { label: 'StyledDropdownMenuItem' })`
    width: 100%;
    height: 100%;
    text-align: left;

    color: ${theme.star.raceCard.dropdown.txtColor};
    font-weight: ${theme.star.fontWeight.regular};
    font-size: ${theme.star.fontSize.xSmall};
`);
